//@ts-nocheck
import React from "react";
import { SafeAreaView, StyleSheet, Platform } from "react-native";
//@ts-ignore
import TypeWriter from "react-native-typewriter";
import Lottie from "lottie-react";
import { TextVW } from "@vlinder-web/text-vfw-widget-react";

export interface ILottieLoaderProps {
    src: string;
    isLoopPlayback: boolean;
    lottieBgColor: string;
    typingDirection?: number;
    typingMinDelay?: number;
    typingMaxDelay?: number;
    loadingText?: string;
    loadingTextStyle?: any;
}

export const LottieLoaderV = (props: ILottieLoaderProps) => {
    return (
        <SafeAreaView
            style={StyleSheet.flatten([
                styles.containerStyle,
                { marginTop: 30 },
            ])}
        >
            {/* <FastImage
        source={props.src}
        resizeMode={FastImage.resizeMode.contain}
        style={StyleSheet.flatten([styles.imageStyle])}
      /> */}
            <Lottie
                animationData={props.src}
                style={StyleSheet.flatten([styles.lottieStyle])}
                loop={props.isLoopPlayback}
                //lottieBgColor={props.lottieBgColor}
            />
            {/* <TypeWriter
        typing={props.typingDirection}
        minDelay={props.typingMinDelay}
        maxDelay={props.typingMaxDelay}
        style={StyleSheet.flatten([
          styles.loadingTextStyle,
          props.loadingTextStyle,
        ])}
      >
        {props.loadingText}
      </TypeWriter> */}
            <TextVW
                type={"title3"}
                numberOfLines={2}
                ellipsizeMode={"tail"}
                style={StyleSheet.flatten([
                    styles.loadingTextStyle,
                    props.loadingTextStyle,
                ])}
            >
                {props.loadingText}
            </TextVW>
        </SafeAreaView>
    );
};

LottieLoaderV.defaultProps = {
    isLoopPlayback: true,
    lottieBgColor: "transparent",
    typingDirection: 1,
    typingMinDelay: 80,
    typingMaxDelay: 80,
    loadingText: "Loading . . .",
};

const styles = {
    containerStyle: {
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
    },
    lottieContainerStyle: {
        paddingTop: 40,
        alignItems: "center",
        justifyContent: "center",
    },
    imageStyle: {
        height: 200,
        width: 200,
    },
    lottieStyle: {
        height: Platform.OS === "ios" ? 300 : 275,
        backgroundColor: "transparent",
    },
    loadingTextStyle: {
        textAlign: "center",
        fontSize: 20,
        letterSpacing: 1.5,
        color: "#1a4677",
        marginTop: 28,
        fontWeight: "bold",
    },
};
